export const trackEvent = (eventName, metaData) => {
    try {
        if (!metaData) {
            window.heap.track(eventName)
            console.log(eventName)
        }
        else {
            window.heap.track(eventName, metaData)
        }
    }
    catch (e) {
        console.log('Failed to send event to Analytics API')
        console.log(e)
    }
}
export const identifyUser = (identifier) => {
    try {
        if (localStorage.getItem('myb_heap_app_id') && window.heap && identifier) {
            window.heap.identify(identifier, 'uuid')
        }
    } catch (e) {
        console.log('Failed to identify user for Analytics API')
        console.log(e)
    }
}
export const HeapEvents = {
    ACCOUNT_VIEWED: 'AccountViewed',
    ACCOUNT_UPDATED: 'AccountUpdated',
    ACCONT_RECOVERY_SUBMITTED_CREDENTIALS: 'heap_click_continue_credentials',
    ACCONT_RECOVERY_SUBMITTED_SECURITY_ANSWER: 'heap_click_continue_security',
    ACCONT_RECOVERY_UPDATED_EMAIL: 'heap_click_continue_update_email',
    ACCONT_RECOVERY_UPDATE_EMAIL_COMPLETE: 'heap_click_update_email_complete',
}